import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { themeColor } from '~/common/utils/theme';

export const HamburguerContainer = styled.div`
  display: flex;
  padding: 32px 0 0 24px;
  flex-direction: column;

  .ant-menu-submenu-title,
  .ant-menu-item {
    span {
      display: flex;
      align-items: center;
    }
    a {
      display: flex;
      align-items: center;
    }
  }

  .ant-menu-vertical > .ant-menu-item,
  .ant-menu-vertical-left > .ant-menu-item,
  .ant-menu-vertical-right > .ant-menu-item,
  .ant-menu-inline > .ant-menu-item,
  .ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title,
  .ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title,
  .ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title,
  .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    padding-left: 0 !important;
    display: flex;
    align-items: center;
  }

  .ant-menu-inline,
  .ant-menu-vertical,
  .ant-menu-vertical-left {
    border-right: 0px !important;
  }

  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: transparent;
  }

  .ant-menu-vertical .ant-menu-item::after,
  .ant-menu-vertical-left .ant-menu-item::after,
  .ant-menu-vertical-right .ant-menu-item::after,
  .ant-menu-inline .ant-menu-item::after {
    border-right: transparent;
  }

  .itemGroup {
    font-size: 16px;
  }

  svg {
    color: ${themeColor('brand.primary')};
  }
`;

export const IconContainer = styled.div`
  display: flex;
  margin-bottom: 3.5rem;
`;

export const OptionContainer = styled.div`
  display: flex;
`;
export const MenuItemContainer = styled(Link)`
  width: 85%;
  margin-left: 1rem;
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${themeColor('neutral.secondaryAlt')};
  margin-bottom: 0.5rem;
  transition: color 0.5s ease;
  cursor: pointer;

  :hover {
    span {
      transition: color 0.5s ease;
      color: ${themeColor('brand.primary')};
    }
  }

  span {
    display: flex;
    align-items: center;
    color: ${themeColor('element.secondary')};
    transition: color 0.5s ease;
  }
`;
